const yourTurnMessage: string = 'Your turn!'

export default yourTurnMessage
